// extracted by mini-css-extract-plugin
export default {"crossSiteLabel":"i3-z","vrsnlCrossSiteLabel":"j3-z"};